import * as yup from 'yup';

export const updateWastageSchema = (
  t: (key: string, options?: { [key: string]: string }) => string,
  maxWastage: number,
  maxWastageString: string,
): yup.AnyObjectSchema =>
  yup.object().shape({
    wastage: yup
      .number()
      .min(0)
      .max(100 * maxWastage, t('closureCloseForm.wastage.update.maxWastageMessage', { maxWastage: maxWastageString })),
  });
